/*
 * ******************************************************************
 * Copyright (c) 2024-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LocalStorageService } from "@app/services";

// @formatter:off
@Component({
    standalone: false,
    selector: "setting-toggle",
    templateUrl: "./setting-toggle.component.html",
    styleUrls: ["./setting-toggle.component.scss"]
})
// @formatter:on
export class SettingToggleComponent implements OnInit {

    @Input()
    public key: string;

    @Input()
    public label: string;

    @Output()
    public valueChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    public settingValue: boolean = false;

    constructor(private localStorageService: LocalStorageService) {
    }

    public ngOnInit(): void {
        this.settingValue = this.localStorageService.getBooleanValue(this.key);
    }

    public settingChanged(): void {
        this.localStorageService.setObject(this.key, this.settingValue);
        this.valueChanged.emit(this.settingValue);
    }
}
